(function () {
  'use strict';

  angular.module('app.scouting').filter('scoutingGameNewLabel', scoutingGameNewLabelFilter);

  function scoutingGameNewLabelFilter() {
    return (instance) => (instance && !instance._id ? '(newly created)' : '');
  }
})();
